import styled from '@emotion/styled';

import { ScrollableSlider } from 'UI';

export const Container = styled.div``;

export const Slider = styled(ScrollableSlider)`
  background: var(--black);
`;
